import MetaInformation from './meta-information';
export default MetaInformation;
